import type { Option } from '@components/forms/GridSelect';

export enum SystemFilterOption {
    Model = 'model',
    Status = 'status',
    AppVersion = 'appVersion',
}

export enum SystemAssigned {
    Assigned = 'assigned',
    Unassigned = 'unassigned',
}

export enum System {
    RapidCut = 'RC2/RC3',
    RCMini = 'RCMini',
}

export enum SystemModel {
    RC = 0,
    RCMINI = 1,
}

export enum SystemStatus {
    Active = 'Active',
    Inactive = 'Inactive',
}

export const SystemModelMap: { [key: string]: System } = {
    0: System.RapidCut,
    1: System.RCMini,
};

/**
 * LEGACY fallback only: ProductID → display label. ProductID is a raw USB id
 * duplicated across products (Bamboo/RC 4 and RCMini both report 67), so it
 * can misidentify machines. Display should use the server-computed `ModelName`
 * (MachineVariant-first) and only fall back here for rows that predate it.
 */
export const SystemVariantMap: { [key: string]: string } = {
    67: 'RCMini',
    4386: 'RC 2.0',
    4400: 'RC 2.1',
    4405: 'RC 2.1',
    10: 'RC 3.0',
};

/**
 * Model filter options. `id` is the MachineVariant token list sent to the
 * backend `model` filter — the backend matches MachineVariant directly and
 * falls back to each variant's legacy ProductID for stations that haven't
 * re-registered yet.
 */
export const MODEL_FILTER_OPTIONS = [
    { id: 'Graphtec6000', label: 'RC 2.0' },
    { id: 'Graphtec6000Plus,GraphTec7000', label: 'RC 2.1' },
    { id: 'RC3.0', label: 'RC 3.0' },
    { id: 'Bamboo', label: 'RC 4' },
    { id: 'RCMini', label: 'RCMini' },
];

export const SYSTEM_STATUS_OPTIONS: Option[] = Object.entries(SystemStatus).map(([label, value]) => {
    return {
        label,
        value,
    };
});

export const COMPATIBILITY_OPTIONS = [System.RCMini, System.RapidCut];
